module.exports = __webpack_public_path__ + "img/2495.f301ffed.png";